import { Chip } from '@mui/material';

interface LanguageBadgeProps {
  language: string;
  size?: 'small' | 'medium';
}

const LANGUAGE_MAP: Record<string, { name: string; flag: string }> = {
  'ja': { name: 'Japanese', flag: '🇯🇵' },
  'es': { name: 'Spanish', flag: '🇪🇸' },
  'en': { name: 'English', flag: '🇬🇧' },
  'fr': { name: 'French', flag: '🇫🇷' },
  'de': { name: 'German', flag: '🇩🇪' },
  'it': { name: 'Italian', flag: '🇮🇹' },
  'pt': { name: 'Portuguese', flag: '🇵🇹' },
  'ru': { name: 'Russian', flag: '🇷🇺' },
  'zh': { name: 'Chinese', flag: '🇨🇳' },
  'ko': { name: 'Korean', flag: '🇰🇷' },
  'ar': { name: 'Arabic', flag: '🇸🇦' },
  'hi': { name: 'Hindi', flag: '🇮🇳' },
};

export const LanguageBadge = ({ language, size = 'small' }: LanguageBadgeProps) => {
  const languageInfo = LANGUAGE_MAP[language.toLowerCase()];
  const label = languageInfo 
    ? `${languageInfo.flag} ${languageInfo.name}`
    : language;

  return (
    <Chip
      label={label}
      size={size}
      variant="outlined"
      sx={{ fontWeight: 500 }}
    />
  );
};
